/*jshint esversion: 6 */
import React, { Component } from 'react';
import * as dataCombiner from "../utils/DataCombiner.js";
import * as paragrGetter from "../Controllers/ParagraphGetter.js";
import * as renderer from "../utils/Renderer.js";
import * as strFuncs from "../utils/stringFuncs.js";
import '../css/utils.css';
import '../css/pageFooter.css';

class PageFooter extends Component {

  constructor(props){
    super(props);
    this.state = {
      isMobileToggleOn: false
    };
  }

  componentWillMount(){
  }


    render() {
   
      let propPar = this.props.paragraphs.slice();
      let propManuses = this.props.manuses.slice();
      let propTempl = this.props.templates.slice();
      //console.log('RENDER footer templates: ', templates);
      let footerObjArr = this.props.footer;
      
      console.log('RENDER footerObj PROPS---- PARAGR, MANUSES; TEMPLTES: ', this.props.paragraphs, this.props.manuses, this.props.templates);
      
      if(footerObjArr !== []){
        console.log('IF RENDER footerObjArr: ', footerObjArr);
        if(propPar && propManuses && propTempl){
            dataCombiner.getPageParagraphs(footerObjArr, propPar, propManuses, propTempl);
        }
      }

        let footerObj = {};
        footerObj = footerObjArr[0];
      console.log('RENDER footerObj fObject: ', footerObj);
      let comps = [];
      if(footerObj){
        comps = renderer.renderPage(footerObj);
      }
          

      return (
        <div className="footer_container">
            {comps}
        </div>
      );
    }

}
  
  export default PageFooter;


// WEBPACK FOOTER //
// ./src/Components/PageFooter.js